"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputSources = void 0;
// List of input sources
exports.inputSources = {
    APP_PARAM: 'App Parameters',
    TASK_PARAM: 'Task Param',
    MT_INPUT: 'Microtask Input',
    MTA_OUTPUT: 'Microtask Assignment Output',
    MT_OUTPUT: 'Microtask Output',
    ITER: 'Loop Object',
    WORKER_PROFILE: 'Worker Profile',
    CONSTANT: 'Constant',
};
//# sourceMappingURL=Types.js.map